/* eslint-disable */
let Vue;
const isArray = Array.isArray;

function isPlainObject(obj) {
  const toString = Object.prototype.toString;
  const OBJECT_STRING = "[object Object]";
  return toString.call(obj) === OBJECT_STRING;
}
function isFunction(val) {
  return typeof val === "function";
}
function isString(val) {
  return typeof val === "string";
}

function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
function parseArgs() {
  let args = [],
    len = arguments.length;
  while (len--) args[len] = arguments[len];

  let locale = null;
  let params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === "string") {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === "string") {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params };
}

function getPathValue(obj, path) {
  if (!isObject(obj)) {
    return null;
  }
  const paths = path.split(".");
  let length = paths.length;
  let last = obj;
  let i = 0;
  while (i < length) {
    const value = last[paths[i]];
    if (value === undefined) {
      return null;
    }
    last = value;
    i++;
  }
  return last;
}

const mixin = {
  beforeCreate() {
    if (this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      this._i18n = this.$root.$i18n;
    }
  },
  beforeMount() {},
  beforeDestroy() {}
};

function extend(Vue) {
  if (!Vue.prototype.hasOwnProperty("$i18n")) {
    Object.defineProperty(Vue.prototype, "$i18n", {
      get: function get() {
        return this._i18n || this.$root.$options.i18n;
      }
    });
  }
  Vue.prototype.$t = function(key, ...values) {
    const i18n = this.$i18n;
    return i18n._t(key, i18n.locale, i18n._getMessages(), this, values);
  };
}
class VueI18n {
  constructor(options) {
    this.version = "0.0.1";
    if (!Vue && typeof window !== "undefined" && window.Vue) {
      VueI18n.install(window.Vue);
    }
    this.fallbackLocale = options.fallbackLocale || "en-US";
    this.options = options;
    this.locale = options.locale || "en-US";
  }
  static install(_Vue) {
    if (process.env.NODE_ENV !== "production" && this.install.installed) {
      warn("already installed.");
      return;
    }
    VueI18n.install.installed = true;
    Vue = _Vue;
    Vue.mixin(mixin);
    extend(Vue);
  }
  _getMessages() {
    return this.options.messages;
  }
  _translate(messages, locale, fallback, key, host, interpolateMode, args) {
    const langs = [this.locale, this.fallbackLocale];
    for (let i = 0; i < langs.length; i++) {
      const step = langs[i];
      const res = this._interpolate(
        step,
        messages[step],
        key,
        host,
        interpolateMode,
        args,
        [key]
      );
      if (res !== null) {
        return res
      }
    }
    return null
  }
  _interpolate(
    locale,
    message,
    key,
    host,
    interpolateMode,
    values,
    visitedLinkStack
  ) {
    if (!message) {
      return null;
    }
    const pathRet = getPathValue(message, key);
    if (isArray(pathRet) || isPlainObject(pathRet)) {
      return pathRet;
    }
    let ret;
    if (pathRet === null) {
      if (isPlainObject(message)) {
        ret = message[key];
      } else {
        return null;
      }
    } else {
      if (isString(pathRet) || isFunction(pathRet)) {
        ret = pathRet;
      }
    }
    return this._render(ret, interpolateMode, values, key);
  }
  _render(message, interpolateMode, values, path) {
    if (isPlainObject(values)) {
      Object.entries(values).forEach(([v, replacement]) => {
        message = message.replace(`{${v}}`, replacement);
      })
    }
    return message
  }
  _t(key, _locale, messages, host, params) {
    if (key) {
      const parsedArgs = parseArgs(...params);
      const ret = this._translate(
        messages,
        _locale,
        this.fallbackLocale,
        key,
        host,
        "string",
        parsedArgs.params
      );
      return ret;
    } else {
      return "";
    }
  }
}

export default VueI18n;
